/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockReportOverviewCtrl
 */
angular.module('mercury.modules.stock.report')
.controller('StockReportOverviewCtrl', ["$filter", "reporttime", "$scope", "$stateParams", "StockReceived", "StockItems", "title", function($filter, reporttime, $scope, $stateParams, StockReceived, StockItems, title) {

  title.set('Stock Overview');
  reporttime.defaultType = 'week';
  $scope.report = $stateParams.report;
  $scope.reportType = reporttime.reportType();

  $scope.purchasesColumnPieOptions = {
    legend: {
      position: 'none'
    }
  };

  $scope.supplierPurchasesColumns = [
    {label: 'Supplier', type: 'string', key: 'supplierName'},
    {label: 'Total Purchases', type: 'number', key: 'totalCost', filter: 'currency'}
  ];

  $scope.superGroupPurchasesPieColumns = [
    {label: 'Super Group', type: 'string', key: 'itemSuperGroupName'},
    {label: 'Total Purchases', type: 'number', key: 'totalCost', filter: 'currency'}
  ];

  $scope.superGroupPurchasesColColumns = [
    {label: 'Period', type: 'string', key: 'time', filter: 'reporttimeformat'}
  ];

  var getSuperGroups = function(superGroupPurchases) {
    var superGroups = [];
    angular.forEach(superGroupPurchases, function(line) {
      if (superGroups.indexOf(line.itemSuperGroupName) == -1) {
        superGroups.push(line.itemSuperGroupName);
      }
    });
    return superGroups;
  };

  /*
   * Parse the results of the ItemSuperGroupPurchases report endpoint into a data table
   * for a column chart
   */
  var groupSuperGroupPurchasesByTime = function(superGroupPurchases) {
    var superGroups = getSuperGroups(superGroupPurchases);

    var rows = [];
    for (var time = moment(reporttime.start()); time.isBefore(reporttime.end()); time.add(1, 'day')) {
      rows.push({time: time.clone(), noData: 0});
    }

    angular.forEach(rows, function(row) {
      angular.forEach(superGroups, function(superGroup) {
        var matchingvalue = $filter('filter')(superGroupPurchases, function(value) {
          return value.itemSuperGroupName == superGroup && row.time.format() == moment(value.time).format();
        });

        row[superGroup] = (matchingvalue.length > 0) ? matchingvalue[0].totalCost : 0;
      });
    });

    return rows;
  };

  /**
   * Transform the Stock API Stock Recieved endpoint response into a form that matches
   * the legacy getTopItemPurchases response
   * @param stockReceivedDocuments 
   * @param topN 
   * @returns 
   */
  const transformToLegacyTopItems = function(stockReceivedDocuments, topN) {
    const topSellingLines = Object.values(stockReceivedDocuments
      .flatMap(doc => doc.lines)
      .reduce((acc, line) => {
        if (!acc[line.itemId]) {
          acc[line.itemId] = {
            itemId: line.itemId, 
            quantityInBaseUnits: 0, 
            totalCost: 0
          }
        } 
        acc[line.itemId].quantityInBaseUnits += line.quantityReceived * line.unitRatio
        acc[line.itemId].totalCost += line.quantityReceived * line.unitCost
        return acc
      },{})
    ).sort((a, b) => b.totalCost - a.totalCost)
    .slice(0, topN);

    return StockItems.getByIds(
      topSellingLines.map(line => line.itemId)
      //I'd prefer an async / await here, but our CI pipeline doesn't currently support it :/
    ).$promise.then(function(items) {
      const topSellingItems = items.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});

      return topSellingLines.map((line) => ({
        stockItemId: line.itemId,
        stockItemName: topSellingItems[line.itemId].name,
        cost: line.totalCost,
        quantity: line.quantityInBaseUnits,
        unitName: topSellingItems[line.itemId].orderingUnitName,
        unitRatio: topSellingItems[line.itemId].orderingUnitRatio
      }));
    });
  }

  /**
   * Transform the Stock API Stock Recieved endpoint response into a form that matches
   * the legacy ItemSuperGroupPurchases response
   * @param {*} stockReceivedDocuments 
   * @returns 
   */
  const transformToLegacySuperGroupPurchases = function(stockReceivedDocuments) {
    const summedData = stockReceivedDocuments
      .flatMap(doc => doc.lines.map(line => ({
        itemSuperGroupName: line.itemCategory.name, 
        time: moment(doc.receivedAt).mResetToStartOfDay(), 
        totalCost: line.unitCost * line.quantityReceived
      })))
      .reduce((acc, line) => {
        if (!acc[line.time]) acc[line.time] = {}; 
        if (!acc[line.time][line.itemSuperGroupName]) acc[line.time][line.itemSuperGroupName] = 0; 
        acc[line.time][line.itemSuperGroupName] += line.totalCost; 
        return acc
      }, {})

    const legacyFormat = []

    //This nested `for` isn't as bad as it looks - the outer will have one key for every time in the report, 
    // and the inner will have one key for each distinct item category that has been recieved that day.
    for (const time in summedData) {
      for (const itemSuperGroupName in summedData[time]) {
        legacyFormat.push({
          itemSuperGroupName: itemSuperGroupName,
          time: time,
          totalCost: summedData[time][itemSuperGroupName]
        });
      }
    }
        
    return legacyFormat;
  }
  
  const transformToLegacySupplierPurchases = (stockReceivedDocuments) => Object.values(
    stockReceivedDocuments.flatMap(doc => doc.lines.map(
      line => ({
        docId: doc.id, 
        supplierId: doc.supplierId, 
        supplierName: doc.supplierName, 
        total:line.quantityReceived * line.unitCost
      })
    ))
    .reduce((acc, line) => {
      if(!acc[line.supplierId]) {
        acc[line.supplierId] = {
          supplierName: line.supplierName, 
          totalCost: 0, docs: new Set()
        }
      } 
      acc[line.supplierId].totalCost += line.total
      acc[line.supplierId].docs.add(line.docId)
      return acc
    }, {})
  ).map(supplier => ({
    supplierName: supplier.supplierName, 
    totalCost: supplier.totalCost, 
    totalCount: supplier.docs.size
  })) 

  $scope.stockReceived = StockReceived.getStockReceivedsByDateRange(reporttime.start(), reporttime.end(), 'Received')

  $scope.loading = $scope.stockReceived.$promise
  .then(function() {
    // 5 was previously hardcoded in the OData params in the super legacy version of this page
    return transformToLegacyTopItems($scope.stockReceived, 5)
      //I'd prefer an async / await here, but our CI pipeline doesn't currently support it :/
      .then(function(topItems) {
        $scope.topItems = topItems;
        $scope.supplierPurchases = transformToLegacySupplierPurchases($scope.stockReceived);
        const legacySuperGroupPurchases = transformToLegacySuperGroupPurchases($scope.stockReceived);

        const superGroups = getSuperGroups(legacySuperGroupPurchases);

        if (reporttime.reportType() == 'day') {
          $scope.superGroupPurchases = legacySuperGroupPurchases;
        } else {
          if (superGroups.length === 0) {
            $scope.superGroupPurchasesColColumns.push({
              label: '', type: 'number', key: 'noData', filter: 'currency'
            });
          } else {
            angular.forEach(superGroups, function(superGroup) {
              $scope.superGroupPurchasesColColumns.push({
                label: superGroup + ' Purchases', type: 'number', key: superGroup, filter: 'currency'
              });
            });
          }

          $scope.superGroupPurchases = groupSuperGroupPurchasesByTime(legacySuperGroupPurchases);
        }

        $scope.totalCost = $filter('sumof')($scope.supplierPurchases, 'totalCost');
        $scope.totalTransactions = $filter('sumof')($scope.supplierPurchases, 'totalCount');

        $scope.superGroupTotals = {};
        angular.forEach(
          $filter('groupby')(legacySuperGroupPurchases, 'itemSuperGroupName'),
          function(superGroupPurchases) {
            const name = superGroupPurchases[0].itemSuperGroupName;
            $scope.superGroupTotals[name] = $filter('sumof')(superGroupPurchases, 'totalCost');
          }
        );
      });
  });
}]);
